import React, { Component } from 'react';
import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import BasicTemplate from './BasicTemplate.js'
import CustomSpinner from './CustomSpinner.js'
import {WAButton} from './Button.js'

class EmailVerification extends Component {

    constructor(props){
        super(props);
        this.state = {
            verified: false
        }
    }

    componentDidMount(){
        this.props.setIsLoading(true);
        const ROOT_URL = process.env.API_URL;
        let jwt = sessionStorage.getItem('jwtUrl');

        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        if(sessionStorage.getItem('jwtUrl')){

            axios.get(`${ROOT_URL}/leads/email_verification/${jwt}`, config)
            .then(res => {
                this.props.throwNextStep();
                sessionStorage.setItem('jwtUrl', null);
            }).catch(error => {
                this.props.setIsLoading(false);
                switch(error.response.status) {
                    case 401:
                        this.setState({
                            verified: false,
                        });
                        break;
                    default:
                        this.setState({
                            verified: false,
                        });
                        break;
                }
            });
        } else{
            this.props.setIsLoading(false);
        }
    }

    render() {
        return (
            <BasicTemplate>
                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                <FormattedHTMLMessage id="app.step_email_verification" description="Email Verification info"/>
                <p>Podés comunicarte con nosotros llamando al:</p>
                <WAButton phone={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                          text={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                          value={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                          gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
            </BasicTemplate>
        );
    }
}

EmailVerification.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

EmailVerification = TopScrolleable(EmailVerification);

EmailVerification = withAuthControl(EmailVerification);

export default EmailVerification;



/** WEBPACK FOOTER **
 ** ./src/components/EmailVerification.js
 **/